import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import Select from "react-select";

import { Code } from '@mui/icons-material';

const AddReceipt = ({ accessedModules, accessedPermission }) => {
const [currentData, setCurrentData] = useState([]);
const [pageCount, setPageCount] = useState(0);
const [dataOffset, setDataOffset] = useState(0);
const dataPerPage = 10;

const [reload, setReload] = useState(false);
const [spinnerLoader, setSpinnerLoader] = useState(false)
const [DesignationName, setDesignationName] = useState(null)
const [DesignationId, setDesignationId] = useState(null)
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // Number of items per page
const dispatch = useDispatch();

const [agentDisable, setAgentDisable] = useState(true);

const customerOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
]
const joborderOptions = [
{ value: 1, label: "Job order 1" },
{ value: 2, label: "Job order 2" },
{ value: 3, label: "Job order 3" },
{ value: 4, label: "Job order 4" },
{ value: 5, label: "Job order 5" },
]
const quotationOptions = [
{ value: 1, label: "Quotation 1" },
{ value: 2, label: "Quotation 2" },
{ value: 3, label: "Quotation 3" },
{ value: 4, label: "Quotation 4" },
{ value: 5, label: "Quotation 5" },
]
const agentOptions = [
{ value: 1, label: "Agent 1" },
{ value: 2, label: "Agent 2" },
{ value: 3, label: "Agent 3" },
{ value: 4, label: "Agent 4" },
{ value: 5, label: "Agent 5" },
]

const salesPersonOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
]

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = []

const totalPages = 1;

// Function to change page
const paginate = (pageNumber) => setCurrentPage(pageNumber);

// Function for "Next" and "Previous" buttons
const handleNext = () => {
if (currentPage < totalPages) { setCurrentPage(currentPage + 1); } }; const handlePrevious=()=> {
    if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
    }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
    }
    // const columns = [
    // { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    // { title: "Date", dataIndex: "date", key: "date" },
    // { title: "Name", dataIndex: "name", key: "name" },
    // { title: "Email", dataIndex: "email", key: "email" },
    // { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    // { title: "Origin", dataIndex: "origin", key: "origin" },
    // { title: "Destination", dataIndex: "destination", key: "destination" },
    // { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    // { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    // { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    // { title: "Action", dataIndex: "action", key: "action" },
    // ];
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    
    const columns = [
        { title: <input type="checkbox"/>, dataIndex: "SNo", key: "SNo" },
        { title: "Bill No", dataIndex: "Name", key: "Name" },
        { title: "Date", dataIndex: "Alias", key: "Alias" },
        { title: "Amount", dataIndex: "NVOCC", key: "NVOCC" },
        { title: "UnPaid", dataIndex: "HomepageURL", key: "HomepageURL" },
        { title: "Amount Rcpt.", dataIndex: "HomepageURL", key: "HomepageURL" },
        { title: "TDS Amt", dataIndex: "HomepageURL", key: "HomepageURL" },
        { title: "Balance", dataIndex: "HomepageURL", key: "HomepageURL" },
    ];

    const dataSource = [
        {
            key: "1",
        }
    ];

    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);

    //select style
    const customControlStyles = base => ({
    height: 20,
    minHeight: 20
    });

    return (
    <>
        <div className="page-wrapper">
            <div className="content">
                <form>
                    <div className="card">

                        <div className="card-body">

                           <div className="row">

                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-between">
                                                <div className='d-flex flex-grow-1 flex-column'>
                                                    <label htmlFor="" className='form-label mb-0'>
                                                    Receipt Number
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input type="text" className="form-control form-control-sm"
                                                            disabled name='order_no' value="123234379848329" />
                                                    </div>
                                                </div>
                                                <div className='ms-2 d-flex flex-grow-1 flex-column '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Date
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input type="date" className="form-control form-control-sm"
                                                            name='search_by' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Organization
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select className='custom-selector' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Type
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">

                                                <Select className='custom-selector' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <label htmlFor="" className='form-label mb-0'>
                                                Mode
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">

                                                <Select className='custom-selector w-100' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Currency 
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">

                                                <Select className='custom-selector' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Exch. Rate
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input type="text" className="form-control form-control-sm" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Amount 
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input type="text" className="form-control form-control-sm" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-between">
                                                <div className='d-flex flex-grow-1 flex-column'>
                                                    <label htmlFor="" className='form-label mb-0'>
                                                    Cheque/Draft No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input type="text" className="form-control form-control-sm"
                                                            disabled name='order_no' value="123234379848329" />
                                                    </div>
                                                </div>
                                                <div className='ms-2 d-flex flex-grow-1 flex-column '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Date
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input type="date" className="form-control form-control-sm"
                                                            name='search_by' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Bank Name
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input type="text" className="form-control form-control-sm" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className='ms-2'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Paid By
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input type="text" className="form-control form-control-sm" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Narration
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input type="text" className="form-control form-control-sm" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="mt-3">
                                    <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                            </div>

                            <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
                Close
            </button>
                        </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </>

    )
    }

    export default AddReceipt